import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";


interface ISalaryProfileReportHeader {
	salaryProfileReportDDlItems?: { label: string; value: any }[];
	// onApplyButtonClickedHandler: () => void;
	onEmployeeStatusSelectionChangeHandler: (params: any) => void;
	selectedItem: number | string;
	setStateRunGetListAPICall: (value: boolean) => void
}

export const SalaryProfileReportHeader: React.FC<
	ISalaryProfileReportHeader
> = ({ salaryProfileReportDDlItems, onEmployeeStatusSelectionChangeHandler, selectedItem, setStateRunGetListAPICall }) => {

	const [showDateRange, setShowDateRange] = useState(false);
	const handleShowDateRangeChange = (e: any) => {
		setShowDateRange(e.value);
		setStateRunGetListAPICall(false)
	};

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}
				
				
				>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					// sx={{ mt: "12px" }}
					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {
							// marginBottom: "-5px!important",

						},
						//  "& .calenderWrapper MuiBox-root":{width:"270px!important"},
					}}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employee"}
						items={salaryProfileReportDDlItems ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeStatus"}
						items={[
							{
								label: "List All Employees",
								value: "all",
							},
							{
								label: "List Active Employees Only",
								value: 100,
							},
							{
								label: "List Died Employees Only",
								value: 200,
							},
							{
								label: "List Inactive Employees Only",
								value: 300,
							},
							{
								label: "List Rehired Employees Only",
								value: 400,
							},
							{
								label: "List Terminated Employees Only",
								value: 500,
							},
						]}
						label={"Status"}
						testId={"employee-status"}
						selectedItem={selectedItem}
						onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
					/>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						// onClickHandler={onApplyButtonClickedHandler}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"dateRange"}
						items={[
							{ label: "Last Profile Only", value: false },
							{ label: "Date Range", value: true },
						]}
						label={"Show Report"}
						testId={"show-report"}
						selectedItem={showDateRange}
						onSelectionChangeHandler={handleShowDateRangeChange}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				{showDateRange && (
					<Grid size={{ xs: 12, sm: 3, md: 2.5, lg: 2.5, xl: 2.5 }}
						sx={{
							// "& .MuiGrid-root": { marginBottom: "-5px!important" },
							// "& MuiGrid-root MuiGrid-container": { maxWidth:"296px!impotant" }
							"& .calenderWrapper ": { fontSize: ".875rem", },
							// "& .MuiBox-root ": { maxWidth: "298px!important",  },
							"& .MuiGrid-root ": { width: "296px!important" },
						}}>
						<>
							<RHookFormDatePicker
								name="startDate"
								testId="start-date"
								label="Start Date"
								labelPosition={LabelPosition.Top}
								format="M dd, yy"
								onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							/>
							<RHookFormDatePicker
								name="endDate"
								testId="end-date"
								label="EndDate"
								labelPosition={LabelPosition.Top}
								format="M dd, yy"
								onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							/>
						</> </Grid>
				)}
				{showDateRange && (
					<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				)}
				<Grid
					size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<span style={{ height: "10px", width: "10px", background: "rgb(246, 245, 204)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Taxable Benefits</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(189, 239, 233)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Exemptions</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(0, 255, 0)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Special Deductions</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(0, 153, 0)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Special Earnings</span>

				</Grid>
				<Grid
					size={{ xs: 12, sm: 3, md: 2.5, lg: 2.5, xl: 2.5 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
				>
					<span style={{ height: "10px", width: "10px", background: "rgb(255, 206, 206)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Deductions at Source</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(219, 219, 177)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Additional Deduction</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(139, 139, 197)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Reimbursements</span>

				</Grid>

			</Grid>

		</>
	);
};
// <Grid
// 	container
// 	size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
// 	sx={{
// 		background: "#fff",
// 		border: "1px solid #e5e7eb",

// 		borderRadius: "2px",
// 		padding: "10px 5px 15px 15px",
// 	}}
// >
// 	<Grid size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }} sx={{ mt: "12px" }}>
// 		<EnhancedDropDownRHFWithLabel
// 			selectName={"status"}
// 			items={[
// 				{ label: "All", value: "all" },

// 				{ label: "Active", value: 100 },
// 				{ label: "Inactive", value: 200 },
// 				{ label: "Terminated", value: 300 },
// 				{ label: "Died", value: 400 },
// 			]}
// 			label={"Status"}
// 			testId={"status-check"}
// 			selectedItem={"all"}
// 		/>
// 	</Grid>
// 	<Grid
// 		size={{ xs: 12, sm: 2, md: 1, lg: 1, xl: 1 }}
// 		sx={{ marginTop: "auto", marginLeft: "5px" }}
// 	></Grid>
// 	<Grid size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }} sx={{ mt: "12px" }}>
// 		<EnhancedDropDownRHFWithLabel
// 			label="Payroll Schedule"
// 			selectName="payFrequency"
// 			items={employeeReportSetupDDlItems ?? []}
// 			selectedItem={"all"}
// 			testId="pay-frequency"
// 		/>
// 	</Grid>
// 	<Grid
// 		size={{ xs: 12, sm: 2, md: 1, lg: 1, xl: 1 }}
// 		sx={{ marginTop: "auto", marginLeft: "5px" }}
// 	></Grid>

// 	<Grid size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }} sx={{ mt: "12px" }}>
// 		<EnhancedDropDownRHFWithLabel
// 			selectName="payMethod"
// 			label="Pay Method"
// 			// required
// 			testId={`Pay-Method-list`}
// 			items={[
// 				{ label: "All", value: "all" },
// 				{ label: "Cheque", value: 100 },
// 				{ label: "Direct Deposit", value: 200 },
// 			]}
// 			selectedItem={"all"}
// 			labelColumns={4}
// 			fieldColumns={8}
// 		/>
// 	</Grid>
// 	<Grid
// 		size={{ xs: 12, sm: 2, md: 1, lg: 1, xl: 1 }}
// 		sx={{ marginTop: "auto", marginLeft: "5px" }}
// 	></Grid>

// 	<Grid size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }} sx={{ mt: "12px" }}>
// 		<EnhancedDropDownRHFWithLabel
// 			selectName={"ProvinceOfEmployment"}
// 			items={[
// 				{ label: "All", value: "all" },
// 				{ label: "British Columbia", value: 100 },
// 				{ label: "Alberta", value: 200 },
// 			]}
// 			label={"Province of Employment"}
// 			testId={"Province-Of-Employment"}
// 			selectedItem={"all"}
// 			// onSelectionChangeHandler={}
// 			// onSelectionChangeHandler={onYearSelectionChangeHandler}
// 			// testId={"year-ddl"}
// 			// selectedItem={selectedYear}
// 		/>
// 	</Grid>

// <Grid size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }} sx={{ mt: "0px" }}>
// 	<EnhancedButtonPrimeReact
// 		label="Apply"
// 		raised
// 		type="submit"
// 		// onClickHandler={onApplyButtonClickedHandler}
// 		severity={EnhancedButtonPrimeReactSeverity.Secondary}
// 	/>
// </Grid>
// </Grid>